import styled from 'styled-components'
import { Row, Card } from 'antd'

export const StyledHeading = styled(Row)`
  ${({ theme }) => `
    h1 {
      color: ${theme['title']};
      padding-top: 50px;
    }
    p {
      color: ${theme['title']};
        font-size: ${theme['font-size']};
        margin-bottom: 50px;
        text-align: left;
    }
    hr {
      border: ${theme['title']};
      font-size: 16px;
      border-bottom-style:inset;
      border-bottom-width:1px;
      border-left-style:inset;
      border-left-width:1px;
      border-right-style:inset;
      border-right-width:1px;
      border-top-style:inset;
      border-top-width:1px;
      margin-top: 9px;
      margin-bottom: 9px;
    }
    padding-bottom: 16px;
`}
`

export const StyledCourseHeading = styled(Row)`
  ${({ theme }) => `
    h1 {
      color: ${theme['title']};
      padding-top: 50px;
    }
    p {
      color: ${theme['title']};
        font-size: ${theme['font-size']};
        margin-bottom: ${theme['margin-lg']};
        text-align: left;
    }
    a{
      text-decoration: underline;
    }
    hr {
      border: ${theme['title']};
      font-size: 16px;
      border-bottom-style:inset;
      border-bottom-width:1px;
      border-left-style:inset;
      border-left-width:1px;
      border-right-style:inset;
      border-right-width:1px;
      border-top-style:inset;
      border-top-width:1px;
      margin-top: 9px;
      margin-bottom: 9px;
    }
    padding-bottom: 16px;
`}
`

export const StyledCard = styled(Card)`
  margin-bottom: 12px;

  .ant-skeleton {
    display: flex;
    flex-direction: column;
  }
  .ant-skeleton-header {
    width: 100%;
    padding: 0px;
  }

  .ant-skeleton-avatar {
    width: 100%;
    height: 272px;
  }
`

export const EmptyCard = styled(Card)`
  margin-bottom: 12px;
  text-align: center;
`

export const StyledBanner = styled.div`
  ${({ theme }) => `
    * {
      box-sizing: border-box
    }
    margin-top: 40px;


    .parentBanner {
      h1{
        margin-bottom: 32px;
        padding-top: 32px;

      }
      p {
        padding: ${theme['padding-med']};
        padding-top: ${theme['padding-zero']};
        margin-top: ${theme['margin-zero']};
        font-size: ${theme['font-size']};

      }
      a {
          color: ${theme['theme']};
      }

      width: 100%;
      height: 18em;
      background: gray;
      margin: -3em auto 1em auto;
      position: relative;
      line-height: 2em;
      font-family: monospace;
      padding: 2em 1em 0;
      background: linear-gradient(${theme['stripe-dark']} 1%, white 1%, white 50%, ${theme['stripe-dark']} 50%, ${theme['stripe']} 52%);
      color: rgb(20,20,50);
      background-size: 100% 4em;
      filter: drop-shadow(2px 2px 5px rgba(black, .25));
      z-index: 2;
      -webkit-animation: print 3s cubic-bezier(.75,.8,0,-0.5);
      &::before, &::after {
        content: '';
        position: absolute;
        top: 0
        width: 2em;
        height: inherit;
        background: salmon;
        background: radial-gradient(transparent 24%, white 24%) 0 0;
        background-size: 2em 2em;
      }
        
      &::before {
        left: -2em;
        border-right: 1px dashed rgba(${theme['stripe']}, .7);
        border-top-left-radius: 2px;
        border-bottom-left-radius: 2px;
      }

      &::after {
        right: -2em;
        border-left: 1px dashed rgba(${theme['stripe']}, .7);
        border-top-right-radius: 2px;
        border-bottom-right-radius: 2px;
      }
    `};
`
